<template lang="pug">
transition(name="slide-fade-up")
  .privacy-banner(v-if="!hasCookie")
    .privacy-banner__close(
      v-if="$mq === 'mobile'"
    )
      icon-button(
        class="mobile-close"
        icon="close"
        label="Close"
        width="16px"
        height="16px"
        @click="closeBanner"
      )
    .privacy-banner__disclaimer
      slot
    primary-button.privacy-banner__cta(
      :label="ctaText"
      @click="handleClick"
      secondary
      :class="$mq === 'mobile' ? 'button--full' : ''"
    )
    .privacy-banner__close(
      v-if="$mq !== 'mobile'"
    )
      icon-button(
        icon="close"
        label="Close"
        width="16px"
        height="16px"
        @click="closeBanner"
      )
</template>

<script>
import PrimaryButton from 'scripts/components/buttons/PrimaryButton.vue';
import IconButton from 'scripts/components/buttons/IconButton.vue';

export default {
  components: { PrimaryButton, IconButton },
  props: {
    ctaText: String
  },
  data () {
    return {
      hasCookie: true,
      cookieName: "privacy_acknowledged=true",
    };
  },
  methods: {
    handleClick () {
      document.cookie = `${this.cookieName};path=/;expires=`;
      this.hasCookie = true;
    },
    // This is only to temporarily close the banner for the page
    closeBanner() {
      this.hasCookie = true;
    }
  },
  mounted () {
    this.hasCookie = document.cookie.includes(this.cookieName)
  }
}
</script>

<style lang="scss">
.privacy-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid $color-mid-light-grey;
  padding: 18px;
  width: 100%;
  background-color: $bg--light;
  text-align: center;

  @include desktop-up {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 36px;
  }

  &__disclaimer {
    margin-bottom: 18px;

    @include desktop-up {
      margin-bottom: 0;
      flex-grow: 1;
      padding-left: $grid-gutter;
      text-align: left;
    }

    p {
      margin: 0;
    }
  }

  a {
    color: $color-charcoal;
    text-decoration: underline;
  }

  &__cta {
    @include desktop-up {
      margin-left: 36px;
    }
  }

  .privacy-banner__close {
    @include tablet-up {
      margin-left: 25px;
    }
  }

  .mobile-close {
    width: 100%;
    text-align: right;
  }
}
</style>
